import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { DxDataGridComponent, DxSelectBoxComponent } from 'devextreme-angular';
import { DxiItemComponent } from 'devextreme-angular/ui/nested';
import dxSelectBox from 'devextreme/ui/select_box';
import { NgxSpinnerService } from 'ngx-spinner';
import { RentriService } from '../../../services/rentri.service';

@Component({
  selector: 'app-movimenti',
  templateUrl: './movimenti.component.html',
  styleUrls: ['./movimenti.component.css']
})
export class MovimentiComponent implements OnInit {

  @Input() itemData

  
  selectBoxUL: any;
  selectBoxReg:any;
  idDefaultUl: string;
  

  elencoUL: Object = []
  registri: Object = [];
  movimenti: Object = [];
  idDefaultRegistri: any;

  constructor(
    private rentriService: RentriService, private sanitizer: DomSanitizer, private loader:NgxSpinnerService,
    private activateRoute: ActivatedRoute,
    ) { }
  @ViewChild('rentriMoviGrid', { static: true }) rentriMoviGrid: DxDataGridComponent;
  @ViewChild('registri', { static: true }) dxRegistri: DxSelectBoxComponent

  ngOnInit() {


    this.activateRoute.queryParams.subscribe(queryParams => {
      console.log('queryParams',queryParams)
    })


     this.idDefaultUl = this.itemData[0].idDefaultUl;

     

     this.rentriService.getElencoSiti().then(unitaLocali => {

      this.unitaLocaliRender(unitaLocali)
    });

     this.rentriService.getRegistri(this.idDefaultUl).then(registri => {
        this.registriRender(registri)
     }) 

     
  } 
  unitaLocaliRender(unitaLocali: Object) {

    this.elencoUL = unitaLocali;

    this.selectBoxUL = {
      width: 350,
      dataSource: this.elencoUL,
      valueExpr: 'identificativo',
      placeholder: 'Scegli unità locale',
      //showClearButton: true,//Rimuovo UL non la voglio cancellare
      value:this.idDefaultUl,
      displayExpr: 'nome',

      onValueChanged: (val) => {
        this.movimenti = '';
        this.registri = '';
        this.idDefaultRegistri = '';
      
        
          if (val.value) {
            this.rentriService.getRegistri(val.value).then(registri => {

              
              
              this.registri ='';
              this.movimenti =''
              this.idDefaultRegistri =''
              

              this.registriRender(registri)
              
            });
          } else {

            this.movimenti ='';
            this.registri ='';
            this.idDefaultRegistri = '';
            this.registriRender('')
          }
       
      },
    };
  }


  registriRender(registri){
   
    
 
      this.registri = registri;
      
      let placeholder = '';
      if(registri.length>0){
        placeholder = 'Scegli registro';
        this.idDefaultRegistri = registri[0].identificativo;

      }else{
        placeholder =  'Nessun registro';
      }
      
       
      

        
      this.selectBoxReg = {
        width: 350,
        dataSource: this.registri,
        valueExpr: 'identificativo',
        placeholder: placeholder,
        showClearButton: true,
        value:this.idDefaultRegistri,
      
        displayExpr:  function(item) {
        
          return item &&  item.identificativo + ' - ' + item.descrizione;
        },
        onContentReady:()=>{
          if(this.idDefaultRegistri != '')
          this.loadMovimenti(this.idDefaultRegistri)
        },
        onValueChanged: (val) => {
          console.log(val)
          
            if (val.value) {
              this.loadMovimenti(val.value)
            }else{
              this.movimenti ='';
              this.rentriMoviGrid.instance.refresh();
            } 
          
          //this.productsStore.load();
        },
      };


  }

  loadMovimenti(idRegistro){
    
    this.rentriService.getMovimenti(idRegistro).then(movimenti => {
      if(movimenti){

        this.movimenti = movimenti
        this.rentriMoviGrid.instance.refresh();
      }
      
    
    });

  }
}
